import { useRouter } from '@/util/hook/custom';
import { useTypedDispatch } from '@/util/hook/custom/useTypedDispatch';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import { selectLiffId } from '@/util/redux/auth';
import { COMMON_ROUTES } from '@/config/route';
import { fetchCareClientVisitorProfile } from '../../redux/module/careClientVisitorProfile';
import { selectIsCareClientVisitorProfileInitialized, trackerIsCareClientVisitorProfileInitializedSetTrue, } from '../../redux/module/tracker';
export const useGetCareClientVisitorProfile = ({ setApiProcessingPool, setApiDonePool, }) => {
    const _id = useSelector(selectLiffId);
    const isCareClientVisitorProfileInitialized = useSelector(selectIsCareClientVisitorProfileInitialized);
    const dispatch = useTypedDispatch();
    const { navigateError } = useRouter();
    useEffect(() => {
        (async () => {
            if (isCareClientVisitorProfileInitialized)
                return;
            const { isSuccess, errorCode } = await dispatch(fetchCareClientVisitorProfile({
                _id,
                setApiProcessingPool,
                setApiDonePool,
            }));
            if (isSuccess) {
                dispatch(trackerIsCareClientVisitorProfileInitializedSetTrue());
            }
            else {
                navigateError(errorCode, COMMON_ROUTES.API_ERROR);
            }
        })();
    }, []);
};
